export default "__VITE_ASSET__29a31205__"